"use strict";
/**
 * Nexus Framework - Cocos Creator插件开发框架
 * 提供简洁优雅的即时模式UI开发体验
 *
 * 版本: 2.1.0 - 重大更新
 * 基于: HTML + CSS + TypeScript
 *
 * 新特性:
 * ✨ 统一主题系统
 * ⚡ UI性能优化 (组件缓存 + 性能监控)
 * 🛡️ 错误处理与插件沙盒
 * 📦 依赖管理与版本兼容性
 * 🎨 增强的插件配置
 * 🔧 Cocos Creator集成工具
 * 📊 智能文件监听和性能监控
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CocosGenerator = exports.Watcher = exports.Dependencies = exports.Errors = exports.Theme = exports.Panel = exports.NexusGUI = exports.Menu = exports.Inject = exports.Injectable = exports.VersionComparator = exports.DependencyInjector = exports.DependencyManager = exports.NexusDependencyManager = exports.PluginState = exports.ErrorCategory = exports.ErrorLevel = exports.DefaultErrorHandler = exports.PluginSandbox = exports.ErrorManager = exports.NexusErrorManager = exports.ThemeManager = exports.NexusThemeManager = exports.ExtensionGenerator = exports.CocosExtensionGenerator = exports.SmartFileFilter = exports.AutoWatcher = exports.NexusAutoWatcher = exports.NexusAutoGenerator = exports.NexusMessage = exports.NexusExtension = exports.NexusWindow = exports.NexusPanel = exports.Plugin = exports.NexusPlugin = void 0;
// 核心框架
var NexusPlugin_1 = require("./Core/NexusPlugin");
Object.defineProperty(exports, "NexusPlugin", { enumerable: true, get: function () { return NexusPlugin_1.NexusPlugin; } });
Object.defineProperty(exports, "Plugin", { enumerable: true, get: function () { return NexusPlugin_1.Plugin; } });
var NexusPanel_1 = require("./Core/NexusPanel");
Object.defineProperty(exports, "NexusPanel", { enumerable: true, get: function () { return NexusPanel_1.NexusPanel; } });
var NexusWindow_1 = require("./Core/NexusWindow");
Object.defineProperty(exports, "NexusWindow", { enumerable: true, get: function () { return NexusWindow_1.NexusWindow; } });
var NexusExtension_1 = require("./Core/NexusExtension");
Object.defineProperty(exports, "NexusExtension", { enumerable: true, get: function () { return NexusExtension_1.NexusExtension; } });
var NexusMessage_1 = require("./Core/NexusMessage");
Object.defineProperty(exports, "NexusMessage", { enumerable: true, get: function () { return NexusMessage_1.NexusMessage; } });
var NexusAutoGenerator_1 = require("./Core/NexusAutoGenerator");
Object.defineProperty(exports, "NexusAutoGenerator", { enumerable: true, get: function () { return NexusAutoGenerator_1.NexusAutoGenerator; } });
var NexusAutoWatcher_1 = require("./Core/NexusAutoWatcher");
Object.defineProperty(exports, "NexusAutoWatcher", { enumerable: true, get: function () { return NexusAutoWatcher_1.NexusAutoWatcher; } });
Object.defineProperty(exports, "AutoWatcher", { enumerable: true, get: function () { return NexusAutoWatcher_1.AutoWatcher; } });
Object.defineProperty(exports, "SmartFileFilter", { enumerable: true, get: function () { return NexusAutoWatcher_1.SmartFileFilter; } });
// Cocos Creator 集成工具
var CocosExtensionGenerator_1 = require("./Core/CocosExtensionGenerator");
Object.defineProperty(exports, "CocosExtensionGenerator", { enumerable: true, get: function () { return CocosExtensionGenerator_1.CocosExtensionGenerator; } });
Object.defineProperty(exports, "ExtensionGenerator", { enumerable: true, get: function () { return CocosExtensionGenerator_1.ExtensionGenerator; } });
// 主题系统
var NexusThemeManager_1 = require("./Core/NexusThemeManager");
Object.defineProperty(exports, "NexusThemeManager", { enumerable: true, get: function () { return NexusThemeManager_1.NexusThemeManager; } });
Object.defineProperty(exports, "ThemeManager", { enumerable: true, get: function () { return NexusThemeManager_1.ThemeManager; } });
// 错误处理系统
var NexusErrorManager_1 = require("./Core/NexusErrorManager");
Object.defineProperty(exports, "NexusErrorManager", { enumerable: true, get: function () { return NexusErrorManager_1.NexusErrorManager; } });
Object.defineProperty(exports, "ErrorManager", { enumerable: true, get: function () { return NexusErrorManager_1.ErrorManager; } });
Object.defineProperty(exports, "PluginSandbox", { enumerable: true, get: function () { return NexusErrorManager_1.PluginSandbox; } });
Object.defineProperty(exports, "DefaultErrorHandler", { enumerable: true, get: function () { return NexusErrorManager_1.DefaultErrorHandler; } });
Object.defineProperty(exports, "ErrorLevel", { enumerable: true, get: function () { return NexusErrorManager_1.ErrorLevel; } });
Object.defineProperty(exports, "ErrorCategory", { enumerable: true, get: function () { return NexusErrorManager_1.ErrorCategory; } });
Object.defineProperty(exports, "PluginState", { enumerable: true, get: function () { return NexusErrorManager_1.PluginState; } });
// 依赖管理系统
var NexusDependencyManager_1 = require("./Core/NexusDependencyManager");
Object.defineProperty(exports, "NexusDependencyManager", { enumerable: true, get: function () { return NexusDependencyManager_1.NexusDependencyManager; } });
Object.defineProperty(exports, "DependencyManager", { enumerable: true, get: function () { return NexusDependencyManager_1.DependencyManager; } });
Object.defineProperty(exports, "DependencyInjector", { enumerable: true, get: function () { return NexusDependencyManager_1.DependencyInjector; } });
Object.defineProperty(exports, "VersionComparator", { enumerable: true, get: function () { return NexusDependencyManager_1.VersionComparator; } });
Object.defineProperty(exports, "Injectable", { enumerable: true, get: function () { return NexusDependencyManager_1.Injectable; } });
Object.defineProperty(exports, "Inject", { enumerable: true, get: function () { return NexusDependencyManager_1.Inject; } });
// 装饰器
__exportStar(require("./Decorators"), exports);
var Decorators_1 = require("./Decorators");
Object.defineProperty(exports, "Menu", { enumerable: true, get: function () { return Decorators_1.Menu; } });
// 类型定义
__exportStar(require("./Types"), exports);
// UI系统 - 带性能优化功能
__exportStar(require("./UI"), exports);
var NexusGUI_1 = require("./UI/NexusGUI");
Object.defineProperty(exports, "NexusGUI", { enumerable: true, get: function () { return NexusGUI_1.NexusGUI; } });
// 工具函数
__exportStar(require("./Utils"), exports);
// 面板装饰器
var NexusPanel_2 = require("./Core/NexusPanel");
Object.defineProperty(exports, "Panel", { enumerable: true, get: function () { return NexusPanel_2.Panel; } });
// 便捷导出 - 常用管理器实例
const NexusThemeManager_2 = require("./Core/NexusThemeManager");
const NexusErrorManager_2 = require("./Core/NexusErrorManager");
const NexusDependencyManager_2 = require("./Core/NexusDependencyManager");
const NexusAutoWatcher_2 = require("./Core/NexusAutoWatcher");
const CocosExtensionGenerator_2 = require("./Core/CocosExtensionGenerator");
exports.Theme = NexusThemeManager_2.ThemeManager;
exports.Errors = NexusErrorManager_2.ErrorManager;
exports.Dependencies = NexusDependencyManager_2.DependencyManager;
exports.Watcher = NexusAutoWatcher_2.AutoWatcher;
exports.CocosGenerator = CocosExtensionGenerator_2.ExtensionGenerator;
